import styled from "styled-components";
import { theme } from "../../../helpers/theme";
const title1 = `NASZA OFERTA:`;
const title2 = `Oferta-strona w przygotowaniu`;
const title3 = `Oferta-strona w przygotowaniu`;

export const Offer = () => {
    return (
        <PageContainer>
            <PageTitle>{title1}</PageTitle>
            <PageText1>
                <b>Zautomatyzowany system zarządzania przestrzenią magazynową w Twoim zasięgu. </b><br />
                Optymalizacja kosztów: System umożliwia skuteczne zarządzanie przestrzenią magazynową, co prowadzi 
                do redukcji kosztów związanych z magazynowaniem. Dzięki możliwości wyboru między magazynem 
                dedykowanym a rozproszonym, przedsiębiorstwa mogą zoptymalizować swoje wydatki na 
                magazynowanie.<br /><br />

                <b>Szybko, łatwo, efektywnie.</b><br />
                Szybkość i efektywność: Automatyzacja procesu generowania ofert oraz natychmiastowa weryfikacja 
                dostępności magazynów za pomocą API przekłada się na znaczną oszczędność czasu. Klienci mogą 
                błyskawicznie znaleźć i zarezerwować przestrzeń magazynową, co przyspiesza cały proces logistyczny.<br /><br />

                <b>Zarządzaj, oszczędzaj, rozwijaj.</b><br />
                Precyzja i dokładność: Dzięki systemowi można uniknąć błędów ludzkich przy tworzeniu ofert i rezerwacji 
                magazynów. Automatyczne generowanie ofert i integracja z API magazynów zapewniają dokładność i 
                pewność co do dostępności przestrzeni. <br /><br />

                <b>Twój czas jest cenny, dlatego automatyzujemy oferty magazynowe.</b><br />
                Elastyczność i skalowalność: System umożliwia elastyczne zarządzanie przestrzenią magazynową, co jest 
                istotne zwłaszcza dla firm o zmiennych potrzebach. Możliwość korzystania z wielu magazynów na raz 
                pozwala na łatwą skalowalność w miarę rozwoju biznesu. <br /><br />

                <b>Twój czas jest cenny, dlatego automatyzujemy oferty magazynowe</b><br />
                Oszczędność czasu: Dzięki automatycznemu generowaniu ofert i efektywnemu zarządzaniu przestrzenią 
                magazynową, użytkownicy zaoszczędzą znaczną ilość czasu, który wcześniej był potrzebny na ręczne 
                procesy poszukiwania przestrzeni i tworzenia ofert. To pozwoli skoncentrować się na kluczowych 
                aspektach biznesowych. <br /><br />

                <b>E-magazyn - Twój skrót do skutecznego składowania</b><br />
                Optymalizacja Trasy Transportu: Dzięki systemowi rozproszonemu, możliwe jest optymalizowanie trasy 
                transportu i minimalizowanie emisji dwutlenku węgla. To z kolei przyczynia się do zrównoważonego 
                zarządzania logistyką, co jest korzystne zarówno z ekologicznego, jak i ekonomicznego punktu widzenia. <br /><br />

                <b>Wspieranie Zasobów Naturalnych</b><br />
                Wspieranie Zasobów Naturalnych: Lepsze wykorzystanie aktywnych magazynów i minimalizacja potrzeby 
                budowy nowych przekłada się na mniejsze obciążenie zasobów naturalnych, takich jak drewno i surowce 
                budowlane, które są często wykorzystywane do budowy nowych obiektów magazynowych. <br /><br />
            </PageText1>   

            <PageTitle>Usługi Magazynowe:</PageTitle> 
            <PageText1>  
                <b>E-commerce: </b><br />
                Oferujemy magazyny dostosowane do potrzeb e-commerce, umożliwiając szybką obsługę zamówień 
                online. <br /><br />

                <b>Crossdocking: </b><br />
                Wykonujemy przeładunki towarów, zarówno przychodzących, jak i wychodzących, zapewniając płynność 
                procesu logistycznego. <br /><br />

                <b>Składowanie na różnych nośnikach: </b><br />
                Nasze magazyny są przygotowane do składowania różnorodnych towarów na różnych nośnikach, od palet 
                po półki i regały. <br /><br /><br />

                <b>Składowanie rozmaitego towaru:</b><br />
                Zapewniamy miejsce do składowania różnych rodzajów towarów, od produktów spożywczych po 
                produkty przemysłowe. <br /><br />

                <b>Składowanie płaskie, półki, regały: </b><br />
                Nasze magazyny oferują różne rodzaje powierzchni składowania, w tym przestrzeń płaską, półki i regały, 
                dostosowane do różnych potrzeb. <br /><br />

                <b>Magazyny różnej klasy: </b><br />
                W zależności od twoich potrzeb dysponujemy magazynami różnych klas aby dostosować się idealnie do 
                twoich wymagań. <br /><br />
            </PageText1>  


            <PageTitle>Nasze Usługi Dodatkowe:</PageTitle> 
            <PageText1>  
                <b>Dostosowane Rozwiązania Magazynowe: </b><br />
                Nasze usługi magazynowe są dostosowywane do indywidualnych potrzeb klientów, zapewniając 
                elastyczność i efektywność. <br /><br />

                <b>Wsparcie Techniczne: </b><br />
                Zapewniamy wsparcie techniczne 24/7, aby zapewnić naszym klientom nieprzerwaną dostępność 
                systemu i rozwiązywać wszelkie problemy. <br /><br />

                <b>Szkolenia i Konsultacje: </b><br />
                Oferujemy szkolenia i konsultacje dotyczące korzystania z naszego systemu oraz doradztwo biznesowe w 
                zakresie optymalizacji procesów magazynowych i logistycznych. <br /><br />

                <b>Zrównoważony Rozwój: </b><br />
                Nasza firma jest zaangażowana w zrównoważony rozwój, dbając o minimalizację negatywnego wpływu na 
                środowisko naturalne w ramach naszych usług.<br /><br />            
            </PageText1>  
            <PageText3>
                Skontaktuj się z nami już dziś, aby dowiedzieć się więcej o naszych usługach i jak możemy pomóc Twojej 
                firmie zoptymalizować procesy magazynowe i logistyczne. Jesteśmy gotowi do współpracy i czekamy na 
                Twój kontakt.
            </PageText3>
        </PageContainer >
    );
};

const PageContainer = styled.div`
padding: 20px 10px;
display: flex;
flex-direction: column;
`;

const PageTitle = styled.h2`
width:100%;
color:${theme.colors.black_primaryText};
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 32px;
line-height: 40px;
padding-bottom:33px;
margin-top: 25px;

// Css do zaślepki poniżej: 
font-size: 24px;
text-align: center;
`

const PageText1 = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14.5px;
line-height: 20px;
padding-bottom:20px;
margin-top: 0px;
`

const PageText2 = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: bold;
font-weight: ${theme.fontWeight.small};
font-size: 20px;
line-height: 20px;
padding-bottom:20px;
`

const PageText3 = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 16px;
line-height: 20px;
padding-bottom:20px;
text-align:center;
margin-top: 25px;
`